export function dynamicLineBreak(content: string, isMobile: boolean) {
    if (content && typeof content === 'string' && isMobile) {
        return content.replace(/<br>/g, '');
    }
    return content;
}
